import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { APPLICATION_ROUTES } from './shared/constants/app-routes';
import { LoginComponent } from './shared/components/login/login.component';
import { AddressesComponent } from './shared/components/addresses/addresses.component';
import { ManageCardsComponent } from './shared/components/profile-options/manage-cards/manage-cards.component';
import { ManageProfileComponent } from './shared/components/profile-options/manage-profile/manage-profile.component';
import { TestDataService } from './shared/resolvers/test-data.service';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: APPLICATION_ROUTES.BASE_URL,
  //   pathMatch: 'full',
  // },
  {
    path: APPLICATION_ROUTES.BASE_URL,
    children: [
      {
        path: APPLICATION_ROUTES.RESTAURANT,
        loadChildren: () =>
          import('./restaurant/restaurant.module').then(
            (m) => m.RestaurantPageModule
          ),
      },
      {
        path: APPLICATION_ROUTES.LOGISTIC,
        loadChildren: () =>
          import('./logistic/logistic.module').then(
            (m) => m.LogisticPageModule
          ),
      },
    ],
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./pages/payment/payment.module').then((m) => m.PaymentPageModule),
  },
  {
    path: 'order-status',
    loadChildren: () =>
      import('./pages/order-status/order-status.module').then(
        (m) => m.OrderStatusPageModule
      ),
  },
  {
    path: APPLICATION_ROUTES.BASE_URL,
    children: [
      {
        path: 'order-history',
        loadChildren: () =>
          import('./pages/order-history/order-history.module').then(
            (m) => m.OrderHistoryPageModule
          ),
          resolve: { data: TestDataService }
      },
      {
        path: "user-profile",
        pathMatch: "full",
        component: ManageProfileComponent,
      },
      {
        path: 'manage-cards',
        pathMatch: 'full',
        component: ManageCardsComponent,
      },
      {
        path: 'addresses',
        pathMatch: 'full',
        component: AddressesComponent,
      },
    ],
  },

  {
    path: 'voucher',
    loadChildren: () =>
      import('./shared/components/discount/voucher/voucher.module').then(
        (m) => m.VoucherPageModule
      ),
  },

  {
    path: APPLICATION_ROUTES.BASE_URL,
    children: [
      {
        path: 'addresses',
        pathMatch: 'full',
        component: AddressesComponent,
      },
      {
        path: 'login',
        pathMatch: 'full',
        component: LoginComponent,
      },
    ],
  },

  {
    path: 'manage-cards',
    pathMatch: 'full',
    component: ManageCardsComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
